import { Popover } from "antd";
import React, { useRef } from "react";
import { icons, text } from './config';
import { onVisibleChange } from "../flow";
import { LirNodeLabelStyle, DefaultNodeLabelStyle } from './style';

export const Node = ({
  setPopoverVisible = () => { },
  renderPopOver,
  el,
  _type,
  t,
}) => {
  const ref = useRef();

  const _open = () => ref.current.click();

  const _onVisibleChange = (value) => {
    setPopoverVisible(value);
    onVisibleChange(value);
  }

  return (
    <Popover
      content={renderPopOver(el.config, _open)}
      trigger="click"
      placement="right"
      onOpenChange={_onVisibleChange}
    >
      <div ref={ref}>
        {el.config.type !== 'lir' ? (
          <DefaultNodeLabelStyle>
            <label className="label">{el.config.label}</label>
            <div className="applications-cont">
              <div className="flex-c">
                <label>{t('Applications')}</label>
              </div>
              {Array.isArray(el?.config?.applications) && (
                <div className="flex-c ml-1">
                  <div className="flex-row">
                    {el.config.applications.includes('pme') && (
                      <div className="app-bullet mr-1" style={{ background: '#FF7875' }} />
                    )}
                    {el.config.applications.includes('cadd') && (
                      <div className="app-bullet" style={{ background: '#68BD45' }} />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="info">
              <div className={`info-cont ${_type}`}>
                <div className="flex-c">
                  {icons[_type] || null}
                </div>
                <p>{t(text[_type] || '')}</p>
              </div>
              <div className={`info-cont id`}>
                <p>#{el.config?.id}</p>
              </div>
            </div>
          </DefaultNodeLabelStyle>
        ) : (
          <>
            <LirNodeLabelStyle>
              <div className="bullet" />
              <p>{t('Local Information Relay')}</p>
            </LirNodeLabelStyle>
            <p
              style={{
                marginBottom: 0,
                position: 'absolute',
                top: '50%',
                right: 10,
                transform: 'translate(0%, -50%)',
                fontSize: 10,
                fontWeight: 600,
                color: '#9A76E8'
              }}
            >
              {el.config.total ? el.config.total : 0}
            </p>
          </>
        )}
      </div>
    </Popover>
  )
};
